<template>
  <div class="ml">
    <b-button
      v-if="!hidden"
      :loading="loading"
      icon-right="plus"
      type="is-primary"
      outlined
      size="is-small"
      @click="onClick"
    />
  </div>
</template>

<script>
export default {
  name: 'PatientCreateOrderAction',
  props: {
    row: {
      type: Object,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.loading = true
        const snapshot = await this.$db
          .collection('companies')
          .doc(this.row.companyId)
          .get()

        const company = snapshot.data()

        if (company) {
          const { moduleTailored, moduleFits, moduleModular, moduleInsole } = company

          if (moduleTailored || moduleFits || moduleModular || moduleInsole) {
            // emit openModal
            this.row.moduleTailored = moduleTailored
            this.row.moduleFits = moduleFits
            this.row.moduleModular = moduleModular
            this.row.moduleInsole = moduleInsole
            this.$emit('openModal', this.row)
          } else if ((!moduleTailored && !moduleFits) || moduleTailored) {
            // emit navToModule
            this.$emit('navToModule', this.row, 'tailored')
          } else {
            // emit navToModule
            this.$emit('navToModule', this.row, 'fits')
          }
        }

        this.loading = false
      } catch (error) {
        this.loading = false
        // enable error log in eslint for this line
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
  },
}
</script>

<style scoped>
.ml >>> button {
  margin-left: 5px !important;
}
</style>
